module.exports = __webpack_public_path__ + "static/media/Innovating Teaching Learning on RTES 2024.115280b8.pdf";